module.exports = __webpack_public_path__ + "img/cascade_event_system_logo.b6fbc5ba.jpg";